export const SLA_MINUTES_IN_FUTURE = 30;

const SLA_MIN_FUTURE_MS = SLA_MINUTES_IN_FUTURE * 60 * 1000;

const parseDateValue = (value) => {
  if (!value) {
    return null;
  }

  const parsed = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return parsed;
};

export const getMinimumSlaDate = (now = new Date()) => new Date(now.getTime() + SLA_MIN_FUTURE_MS);

export const toLocalDateTimeInputValue = (value) => {
  const parsed = parseDateValue(value);
  if (!parsed) {
    return '';
  }

  const localDate = new Date(parsed.getTime() - parsed.getTimezoneOffset() * 60000);
  return localDate.toISOString().slice(0, 16);
};

export const toIsoFromLocalDateTime = (value) => {
  const parsed = parseDateValue(value);
  return parsed ? parsed.toISOString() : null;
};

export const isSameTimestamp = (left, right) => {
  const leftDate = parseDateValue(left);
  const rightDate = parseDateValue(right);

  if (!leftDate || !rightDate) {
    return false;
  }

  return leftDate.getTime() === rightDate.getTime();
};

export const getMinimumSlaInputValue = (now = new Date()) => toLocalDateTimeInputValue(getMinimumSlaDate(now));

export const getSlaPayloadValue = (value, originalValue = null) => {
  if (!value) {
    return null;
  }

  const originalLocalValue = toLocalDateTimeInputValue(originalValue);
  if (originalLocalValue && value === originalLocalValue) {
    return originalValue;
  }

  return toIsoFromLocalDateTime(value);
};

export const getSlaValidationMessage = ({
  value,
  originalValue = null,
  allowUnchangedPast = false,
  required = false,
  now = new Date(),
} = {}) => {
  if (!value) {
    return required ? 'SLA is required' : '';
  }

  const parsed = parseDateValue(value);
  if (!parsed) {
    return 'SLA must be a valid date and time';
  }

  const originalLocalValue = toLocalDateTimeInputValue(originalValue);
  if (allowUnchangedPast && originalLocalValue && value === originalLocalValue) {
    return '';
  }

  if (parsed.getTime() < getMinimumSlaDate(now).getTime()) {
    return `SLA must be at least ${SLA_MINUTES_IN_FUTURE} minutes in the future`;
  }

  return '';
};

export const formatSlaDisplay = (value) => {
  const parsed = parseDateValue(value);
  return parsed ? parsed.toLocaleString() : 'Not set';
};

export const formatSlaTableDisplay = (value) => {
  if (!value) {
    return '—';
  }

  const raw = String(value);
  if (raw.includes('T')) {
    return raw.replace('T', ' ').replace(/:\d{2}(?:\.\d+)?Z?$/, '');
  }

  return raw;
};
